<script lang="ts">
	/*
	 * Важная рассылка ANDRESOT карточкой поверх экрана.
	 *
	 * Обычная рассылка просто приходит сообщением в чат «ANDRESOT». Важная —
	 * туда же, и вдобавок один раз показывается здесь, чтобы её не пропустили.
	 * Несколько важных подряд идут по очереди: закрыли одну — видна следующая.
	 */
	import { app } from '$stores/app.svelte';
	import { ui } from '$stores/ui.svelte';
	import { openBroadcastLink } from '$utils/broadcastLink';
	import { getAuthorizationGeneration } from '$api/client';
	import { toasts } from '$stores/toasts.svelte';
	import Modal from './Modal.svelte';
	import BroadcastContent from './BroadcastContent.svelte';

	let current = $derived(app.announcements[0]);

	function follow(): void {
		const announcement = current;
		if (!announcement?.link) return;
		app.dismissAnnouncement(announcement.id);
		openBroadcastLink(announcement.link.url, announcement.messageId);
	}

	/** «В чат»: там рассылку можно перечитать потом. */
	function openChat(): void {
		const announcement = current;
		if (!announcement?.chatId) return;
		const generation = getAuthorizationGeneration();
		app.dismissAnnouncement(announcement.id);
		void app
			.openServerChat(announcement.chatId)
			.then(() => {
				if (generation === getAuthorizationGeneration()) ui.openChat(announcement.chatId!);
			})
			.catch(() => {
				if (generation === getAuthorizationGeneration()) toasts.error('Не удалось открыть чат');
			});
	}
</script>

{#if current}
	<Modal
		title={current.title}
		cancelLabel="Понятно"
		confirmLabel={current.link?.label}
		onconfirm={current.link ? follow : undefined}
		oncancel={() => app.dismissAnnouncement(current!.id)}
	>
		<BroadcastContent
			title={current.title}
			body={current.body}
			textEntities={current.textEntities}
			attachments={current.attachments}
		/>
		{#if current.chatId}
			<button class="chat-link" onclick={openChat}>Открыть в чате «ANDRESOT»</button>
		{/if}
	</Modal>
{/if}

<style>
	.chat-link {
		margin-top: var(--spacing-s);
		padding: 0;
		border: 0;
		background: none;
		color: var(--accent-primary);
		font: var(--text-caption-medium);
		cursor: pointer;
	}
</style>
